module.exports = __webpack_public_path__ + "static/titleLogo-min-a4b54f7dbd9583531a0e8f20dac96db8.png";